import React from 'react';

const LoadingState = ({ count = 6 }) => {
  return (
    <div className="space-y-4">
      {Array.from({ length: count })?.map((_, index) => (
        <div
          key={index}
          className="flex items-center justify-between p-4 bg-card border border-border rounded-xl animate-pulse"
        >
          <div className="flex items-center space-x-4 flex-1">
            {/* Avatar Skeleton */}
            <div className="w-12 h-12 bg-muted rounded-full flex-shrink-0" />
            
            {/* Content Skeleton */}
            <div className="flex-1 min-w-0">
              <div className="h-4 bg-muted rounded w-32 mb-2" />
              <div className="h-3 bg-muted rounded w-24" />
            </div>
          </div>
          
          {/* Button Skeletons */}
          <div className="flex items-center space-x-2 flex-shrink-0">
            <div className="h-8 bg-muted rounded w-20" />
            <div className="h-8 bg-muted rounded w-16 hidden sm:block" />
          </div>
        </div>
      ))}
    </div>
  );
};

export default LoadingState;